import addComponentLoader, { importWithRetry } from '@/utils/component-loader'
import { defineAsyncComponent } from 'vue'

const componentMapping =  {
  petitionStartForm: defineAsyncComponent(() => importWithRetry(() => import(/* webpackMode: "lazy" */ /* webpackChunkName: "petition-start-form" */ './form')))
}

addComponentLoader(componentMapping, {}, () => importWithRetry(() => import(/* webpackMode: "lazy" */ /* webpackChunkName: "petition-start-store-getter" */ './store')))
